import { render, staticRenderFns } from "./BusinessMatchEmailSent.vue?vue&type=template&id=6bba5a00&scoped=true"
import script from "./BusinessMatchEmailSent.vue?vue&type=script&lang=ts"
export * from "./BusinessMatchEmailSent.vue?vue&type=script&lang=ts"
import style0 from "./BusinessMatchEmailSent.vue?vue&type=style&index=0&id=6bba5a00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bba5a00",
  null
  
)

export default component.exports